import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Tooltip, Row, Tag, Space, Col, Radio, Input, Empty, Select, Checkbox, InputNumber, Typography, Skeleton, List, Alert, Switch } from "antd";
import { message } from "components/UI/AntdAppHelper";
import {
  PlusOutlined,
  CloseCircleOutlined
} from "@ant-design/icons";
import axios from "axios";
import Spinner from "components/UI/Spinner/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { activeAdjustedExperienceSelector } from "views/Experiences/selector";
import {actions as genericActions} from "App/genericRedux";
import {
  activeTopicIdSelector, activeTopicSelector,
} from "views/Segments/Topics/selector";
import {actions as segmentActions} from "views/Segments/redux"
import _, { filter, find, isEmpty } from "lodash";
import { getAIServiceBaseURL, getDestinationPositionLex, getFromLS, getPageCountFromURL, removeHTMLTagsFromText, renderMathInElement, showSyllabusTopicFilterForDPSubjectsInAIModal, showSyllabusTopicFilterForMYPSubjectsInAIModal, updateConfigHeaderForDemoUseStagingAI } from "lib/utils/helperMethods";
import { currentUserSelector, enabledFeaturesSelector } from "views/Auth/Login/selector";
import "./GenerateAIWithPrompt.scss"
import loadable from "@loadable/component";
import { ShowText, ShowTextContent } from 'components/UI/Segment/UIHelper'
import { SelectCommandTermLabel, SelectDifficultyLevel, SelectOrgQuestionbank,SelectPaperType,SelectTeachingLevel,SelectTreeSyllabusContentsSingle } from "components/AppSpecific/SelectSubject/SelectSubject";
import GenericFilter from "./GenericFilter";
import MrTranslate, { useTranslate } from "lib/MrTranslate/MrTranslate";
import MagicButton from "./MagicButton";
import RenderHtml from "components/UI/RenderHtml/RenderHtml";
import { MrSelect } from "mr_react_framework";
import { commandTermsSelector, syllabusTopicsSelector } from "App/genericSelector";
import { orgquestionbanksSelector } from "views/Questionbanks/selector";
import { segmentsCreateLoadingSelector } from "../selector";
import { FaRegStopCircle } from "react-icons/fa";
import RateAiResult from "./RateAiResult";
import { aiModelSelector } from "views/Orgs/selector";
import SelectFromComputer from "components/UI/Media/SelectFromComputer";
import MediaUI from "components/UI/Media/MediaUI";
import CKETextContent from "../CKETextContent/CKETextContent";
import { CKETextGenerateAISourceTools } from "components/UI/CKEditor/CKEConfig";
import MediaShow from "components/UI/Media/MediaShow";

const { Text } = Typography;

const SelectQuestionbankUUID = MrSelect({
  actions: genericActions,
  resourceName: "questionbanks",
  config: {
    url: "/questionbanks",
    // params: { key: "value" },
    processData: (data, props) => {
      return data.map((item) => {
        return { label: item.title, value: item.uuid };
      });
    },
    widgetConfig: {
      showSearch: false, // if false, this will either load entire data from backend on widget load or onSearch
      // TBD: If false, need to be able to search. Also if can do regular select from redux with this component, then can use same everywhere.
      // placeholder: "Select questionbank",
      placeholder: <MrTranslate id={"CommonText.select_questionbank"} />
      // mode: "multiple",
      // style: { width: "300px" },
    },
  },
});

const ReactPlayer = loadable(() =>
  import(/* webpackChunkName: "react-player" */ "react-player")
);
const { TextArea } = Input;


const buildOptions = (optionsFor, content) => {
  return content.options.map((option, index) => ({
    checked: optionsFor === 'teacher' && content.answer === option,
    content: option,
    placeholder: `Option ${index + 1}`,
    id: index
  }));
};

const findSyllabusTopicKey = (topics, topicName, returnKey) => {
  let syllabusTopicKey;

  for (const tag of topics) {
    if (tag.name.toLowerCase() === topicName.toLowerCase()) {
      syllabusTopicKey = tag[returnKey];
      console.log("syllabusTopicUUID==>", topics, topicName, returnKey)

      break;
    } else if (tag.children) {
      syllabusTopicKey = findSyllabusTopicKey(tag.children, topicName, returnKey);
      if (syllabusTopicKey) {
        break;
      }
    }
  }

  return syllabusTopicKey;
};


const ModalTitle = () => {
  const mrIntl = useTranslate();
  return (
    <Space>
     <MrTranslate id={"GenerateAIWithPrompt.generate_question_with_ai_msg"} />
     <Tag className="ai-header-beta-tag">{mrIntl("CommonText.beta")}</Tag>
    </Space>
  );
};

const ModalFooter = (props) => {
  let { magicButtonRenderInFooter, error, generatedQuestions } = props;
  const mrIntl = useTranslate()
  return (
    <Row>
      <Col span={12}></Col>
      {/* <Col span={6} className="text-right">
        {error && mrIntl("CommonText.something_went_wrong_please_try_again")}
      </Col> */}
      <Col span={8}>
        {error && <Alert type="warning" message={mrIntl("CommonText.something_went_wrong_please_try_again")} style={{padding: "4px 12px", maxWidth: "290px", float: "right"}}/>}  
        {!error && generatedQuestions.length > 0 && (
          <div className="text-right">
            <RateAiResult
              generatedData={generatedQuestions}
              action="generate_segments"
            />
          </div>
        )}
      </Col>
      <Col span={4} className="text-right">
        <Space>{magicButtonRenderInFooter}</Space>
      </Col>
    </Row>
  );
};

const SelectStrands = MrSelect({
  config: {
    isJsx: true,
    processData: (data, props) => {
      let options = []
      return options
    },
    widgetConfig: {
      showSearch: true,
      placeholder: <MrTranslate id={"StrandsForm.select_strands_placeholder"}/>,
    },
  },
});

const SelectStrandsForm = ({ strands, setSelectStrands, criteria, segment, disabled }) => {

  const activeExperience = useSelector(activeAdjustedExperienceSelector());
  const currentUser = useSelector(currentUserSelector())
  let mypOP = currentUser.org.org_programmes && currentUser.org.org_programmes.find(op => op.code === "myp");
  let currentGrade = mypOP.grades.find(grade => grade.label === activeExperience.custom_fields.grade_item_label)
  const newStrands = [];
  const [data, setData] = useState([]);
  const experienceCritera = activeExperience && activeExperience.rubric && activeExperience.rubric.criteria && activeExperience.rubric.criteria.length > 0 && activeExperience.rubric.criteria;
  const segmentCriterium = segment && segment.criterium_associations_attributes && segment.criterium_associations_attributes.length > 0 && segment.criterium_associations_attributes

  
  useEffect(() => {
    criteria &&
      criteria.length > 0 &&
      criteria.map((item) => {
        let currentCriteria = item.title && item.title.split("-")[0];
        const criteriaStrands = filter(
          experienceCritera,
          (item) => item.title === currentCriteria
        )[0]
        const findCriteriaStrands = (criteriaStrands && criteriaStrands.strands) || []
        if (findCriteriaStrands.length) {
          let finalStrands = find(
            findCriteriaStrands,
            (item) => item.grade_code && item.grade_code === currentGrade.code
          );
          let findFinalStrands = finalStrands && finalStrands.strands
          console.log("findCriteriaStrands==>", findFinalStrands);

          if (findFinalStrands) {
            let finalOptions = findFinalStrands && findFinalStrands.length > 0 && findFinalStrands.map((item) => {
              const obj = {
                label: `${item.label} - ${item.desc}`,
                value: `${item.label} - ${item.desc}`,
              };
              segmentCriterium &&
                segmentCriterium.map((st) => {
                  st.strands &&
                    st.strands.length > 0 &&
                    st.strands.map((strand) => {
                      if (strand.label === item.label) {
                        setSelectStrands((prevSelectStrands) => [
                          ...(prevSelectStrands || []),
                          `${item.label} - ${item.desc}`,
                        ]);
                      }
                    });
                });
              return obj;
            });
            const objToPush = {
              label: currentCriteria,
              options: finalOptions,
            };
            console.log("finalstrands==>", newStrands, strands);
  
            newStrands.push(objToPush);
          }
        }
      });
    console.log("criteria==>", newStrands);
    // Doing this to remove strands when we uncheck the criteria
    if (strands) {
      let finalStrands = [];
      
      newStrands.forEach(newStrand => {
        strands.forEach(strand => {
          const lowerCaseLabel = newStrand.label.toLowerCase();
          const lowerCaseStrand = strand.toLowerCase();

          if (lowerCaseStrand.startsWith(lowerCaseLabel)) {
            finalStrands.push(strand);
          }
        });
      });
      setSelectStrands(finalStrands)
    }
    setData(newStrands);
  }, [criteria.length]);

  const handleChange = (e) => {
    setSelectStrands(e)

  };
  return (
    criteria &&
    criteria.length > 0 && (
      <>
        <div>Select Strands</div>
        <SelectStrands
          className={"m-t-5"}
          disabled={disabled}
          value={strands}
          onChange={handleChange}
          config={{
            widgetConfig: {
              style: { width: "350px" },
              options: data,
              mode: "multiple",
            },
          }}
        />
      </>
    )
  );
};

const SelectCriteria = ({ criteria = [], setCriteria, segment, disabled, showError, setShowError, isMypAl }) => {
  const mrIntl = useTranslate();
  const activeExperience = useSelector(activeAdjustedExperienceSelector());
  const [showPointsErrorMsg, setShowPointsErrorMsg] = useState(false)

  let errorMessage = null;

  if (showError && criteria.length === 0) {
    if (!showPointsErrorMsg) {
      errorMessage = "Please select at least one criteria";
    } else {
      errorMessage = "Please select points";
    }
  }


  let checkboxOptions = [];

  if (activeExperience && activeExperience.rubric && activeExperience.rubric.criteria) {
    activeExperience.rubric.criteria.map((criteriaItem) => {
      const objToPush = {
        label: criteriaItem.title + "-" + criteriaItem.label,
        value: criteriaItem.label,
        id: criteriaItem.id
      }
      checkboxOptions.push(objToPush)
    })
  }
  let defaultValue = [];
  useEffect(() => {
    if (criteria && criteria.length > 0 && showError && !showPointsErrorMsg) {
      setShowError(false)
    }
  }, [criteria && criteria.length])

  useEffect(() => {
    if (criteria && criteria.length > 0) {
      criteria.map(item => defaultValue.push(item.title.split("-")[1]))
    }

    if (segment && segment.criterium_associations_attributes.length > 0) {
      const updatedCriteria = segment.criterium_associations_attributes.map(ca => {
        const criteriaItem = {
          id: ca.criterium_id,
          title: ca.custom_fields.title + "-" + ca.custom_fields.label,
        };
        if (ca.points) {
          criteriaItem.marks = parseInt(ca.points);
        }
        defaultValue.push(ca.custom_fields.label)
        return criteriaItem;
      });
      
      setCriteria([...(criteria || []), ...updatedCriteria]);


    }
  }, []);

  const handleChange = (selectedLabels) => {
    console.log("criteria inside==>", criteria, selectedLabels);
    if (selectedLabels.length === 0) {
      setShowError(false);
      setShowPointsErrorMsg(false)
      errorMessage = null;
    }

    const updatedCriteria = activeExperience.rubric.criteria.reduce(
      (result, item) => {
        const marks = (criteria || []).find((ct) => ct.id === item.id) || { marks: 1 };
        if (selectedLabels.includes(item.label)) {
          let objToPush = {
            id: item.id,
            title: `${item.title}-${item.label}`,
          };
          if (!isMypAl) {
            objToPush.marks = marks.marks;
          }
          result.push(objToPush);
        }
        return result;
      },
      []
    );

    setCriteria(updatedCriteria);
  };
  
  const findValue = (id) => {
    const item = find(criteria, (item) => item.id === id)
    return item && item.marks;
  }

  const disabledInput = (id) => {
    let isCriteriaSelected = find(criteria, (ct) => ct.id === id)
    return disabled || !isCriteriaSelected;
  }
  

  return (
    <>
      <div>Select criteria</div>
      <Checkbox.Group
        disabled={disabled}
        className="select-critera m-t-5"
        defaultValue={defaultValue}
        options={checkboxOptions.map((option) => ({
          label:
            activeExperience.rubric.type_c === "criteria_with_points" ? (
              <Space direction="vertical">
                <InputNumber
                  controls={false}
                  disabled={disabledInput(option.id)}
                  min={1}
                  value={findValue(option.id)}
                  className="rubric-points-input"
                  key={`criteria-form-input-${option.id}`}
                  addonBefore={
                    <Tooltip title={option.label}>
                      <div className="addon-label">
                        {option.value}
                      </div>
                    </Tooltip>
                  }
                  placeholder={mrIntl("CommonText.pts")}
                  onChange={(e) => {
                    if (!e) {
                      setShowPointsErrorMsg(true)
                      setShowError(true)
                    } else {
                      setShowPointsErrorMsg(false)
                      setShowError(false)
                    }
                    const updatedCriteria = criteria.map((item) => {
                      if (item.id === option.id) {
                        return {
                          ...item,
                          marks: e,
                        };
                      }
                      return item;
                    });
                    setCriteria(updatedCriteria);
                  }}
                />
              </Space>
            ) : (
              option.label
            ),
          value: option.value,
        }))}
        onChange={(e) => handleChange(e)}
      />
      <br />
      {errorMessage && <Text type="danger">{errorMessage}</Text>}
    </>
  );
};

const addToSegment = (addSegmentOptions) => {
  const {questionType, setAddButtonLoading, content, activeExperience, parentId, destinationPosition, previousId, marks, createAtIndex, activeTopicId, dispatch, mrIntl, commandTermId, syllabusTopicId, paperTypeId, teachingLevelId, difficultyLevelId, showCriteria, criteria, strands, isNested, subPartLength, addAll=false, setAddAllButtonLoading} = addSegmentOptions;
  
  console.log("adding all==>", addAll);
  if (!addAll) {
    setAddButtonLoading(true);
  }

  
  let question_segments_attributes = {
    question_type:
      questionType === "long_answer"
        ? "cke_subjective"
        : questionType === "mcq"
          ? "mcq_single"
          : questionType === "nested_question"
            ? "group"
            : questionType,
    content: content.question,
  };

  if (questionType === 'mcq') {
    question_segments_attributes = {
      ...question_segments_attributes,
      teacher_json: {
        segment_data: {
          options: buildOptions('teacher', content)
        }
      },
      student_json: {
        segment_data: {
          options: buildOptions('student', content)
        }
      }
    };
  }
  let createSegmentPayload = {
    segment: {
      experience_id: activeExperience.id,
      parent_id: parentId,
      destination_position: destinationPosition,
      previous_id: previousId,
      points: marks,
      segment_type: "question",
      settings: {
        mode: "exam_mode",
      },
      custom_fields: {
        ai_used: {
          content: true
        },
      },
      question_segments_attributes: [question_segments_attributes],
      relation_items: [{}],
      tag_items_attributes: []
    }
  };

  if (commandTermId) {
    createSegmentPayload.segment.tag_items_attributes.push({
      itemable_type: "Segment",
      tag_id: commandTermId,
    });
  }
  if (syllabusTopicId) {
    createSegmentPayload.segment.tag_items_attributes.push({
      itemable_type: "Segment",
      tag_id: syllabusTopicId,
    });
  }
  if (paperTypeId) {
    createSegmentPayload.segment.tag_items_attributes.push({
      itemable_type: "Segment",
      tag_id: paperTypeId,
    });
  }
  if (teachingLevelId) {
    createSegmentPayload.segment.tag_items_attributes.push({
      itemable_type: "Segment",
      tag_id: teachingLevelId,
    });
  }
  if (difficultyLevelId) {
    createSegmentPayload.segment.tag_items_attributes.push({
      itemable_type: "Segment",
      tag_id: difficultyLevelId,
    });
  }
  console.log("segment-ids===>",commandTermId, syllabusTopicId, paperTypeId, teachingLevelId, difficultyLevelId)
  if (showCriteria && criteria.length > 0) {
    console.log("strands adding==>", strands, criteria);
    const criteriumAssociationsAttributes = criteria.map((item) => {
      // The ...rest syntax is used to capture any remaining properties of the item object into the rest variable and then pass it without modifying them.
      const { id, marks, title: criteriaTitle, ...rest } = item;
      const [title, label] = criteriaTitle.split("-");

      const matchingStrands = strands && strands
        .filter((strand) => {
          const [strandTitle] = strand.split("-");
          return strandTitle.trim().includes(title.trim());
        })
        .map((strand) => {
          const [strandTitle] = strand.split("-");
          return { label: strandTitle.trim() };
        });

      const strandsToAdd =
        matchingStrands && matchingStrands.length > 0
          ? matchingStrands
          : undefined;

      const criteriaWithStrands = {
        ...rest,
        criterium_id: id,
        associable_type: "Segment",
        points: marks,
        custom_fields: {
          title,
          label,
        },
        strands: strandsToAdd,
      };

      return criteriaWithStrands;
    });

    createSegmentPayload.segment.criterium_associations_attributes = criteriumAssociationsAttributes;
  }
  

  const segmentActionOptions = {
    createAtIndex: createAtIndex,
    parentId: activeTopicId,
    previousId: previousId,
    destinationPosition: destinationPosition,
    success: {
      showMessage: false,
    },
    successCallback: (data) => {
      if ((isNested && createAtIndex + 1 === subPartLength) || !isNested) {
        if (!addAll) {
          message.success(
            mrIntl("GenerateAIWithPrompt.new_question_added_success_msg")
          );
          setAddButtonLoading(false);
        }
      }

      let updatedSegment = data.data.segment.data.attributes;
      console.log("updatedSegment ai==>", updatedSegment);
     
      if (questionType === "nested_question" && content.sub_parts.length > 0) {
        async function addNestedQuestions(index) {
          if (index < content.sub_parts.length) {
            const nestedPositionArray = ["U", "j", "r"]; //need to change this to dynamic - for this spoke with @Uttam - will calculate the positions on the FE first then will pass it instead of calculating on the BE
            try {
              await new Promise(resolve => setTimeout(resolve, 1000));
      
              const addSegmentOptions = {
                questionType: "long_answer",
                setAddButtonLoading,
                content: { question: content.sub_parts[index].question },
                activeExperience,
                parentId: updatedSegment.id,
                destinationPosition: getDestinationPositionLex(nestedPositionArray[index]),
                previousId: updatedSegment.id,
                marks: content.sub_parts[index].points,
                createAtIndex: index,
                activeTopicId,
                dispatch,
                mrIntl,
                commandTermId,
                syllabusTopicId,
                paperTypeId,
                teachingLevelId,
                difficultyLevelId,
                showCriteria,
                criteria,
                strands,
                isNested,
                subPartLength
              };

              await addToSegment(addSegmentOptions);
              if (activeExperience && !_.isEmpty(activeExperience)) {
                dispatch(segmentActions.setParentsPoints({ updatedSegment }));
             }
      
              console.log(" adding sub-part at index:===> success", index);
            } catch (error) {
              console.error(" adding sub-part at index:===> error", index, error);
            }
      
            await addNestedQuestions(index + 1); // Recursively call with the next index
          } else {
            setAddAllButtonLoading(false);
            // All questions added, do something if needed
          }
        }
      
        addNestedQuestions(0); // Start the recursive loop with index 0
      }
      if (activeExperience && !_.isEmpty(activeExperience)) {
        dispatch(segmentActions.setParentsPoints({ updatedSegment }));
     }

    },
    errorCallback: (data) => {
      setAddButtonLoading(false);
    }
  };

  activeExperience && activeExperience.id && activeTopicId && dispatch(segmentActions.create(createSegmentPayload, segmentActionOptions));
};

const AddGeneratedSegmentBtn = (props) => {
  const { content, questionType, marks, createAtIndex, destinationPosition, previousId, showCriteria, criteria, strands, commandTermId, syllabusTopicId, paperTypeId, teachingLevelId, difficultyLevelId, parentId, addAllButtonLoading, setAddAllButtonLoading } = props;
  console.log("AddGeneratedSegmentBtn==>", props)
  const [addButtonLoading, setAddButtonLoading] = useState(false);
  const mrIntl = useTranslate()
  const dispatch = useDispatch();
  const activeTopicId = useSelector(activeTopicIdSelector());
  const activeExperience = useSelector(activeAdjustedExperienceSelector())
  const segmentsCreateLoading = useSelector(segmentsCreateLoadingSelector())
  console.log("segmentsCreateLoading ===>", segmentsCreateLoading);
  const [isNested, setIsNested] = useState(questionType === "nested_question" ? true : false);
  const subPartLength = content.sub_parts && content.sub_parts.length;


  const addSegmentOptions = {
    questionType,
    setAddButtonLoading,
    addAllButtonLoading,
    setAddAllButtonLoading,
    content,
    activeExperience,
    parentId,
    destinationPosition,
    previousId,
    marks,
    createAtIndex,
    activeTopicId,
    dispatch,
    mrIntl,
    commandTermId,
    syllabusTopicId,
    paperTypeId,
    teachingLevelId,
    difficultyLevelId,
    showCriteria,
    criteria,
    strands,
    isNested,
    subPartLength,
  };
  console.log("loading in adding==>", addButtonLoading, segmentsCreateLoading, addAllButtonLoading, isNested)

  return (
    <Tooltip title={mrIntl("CommonText.add")}>
      <Button
        type="primary"
        size={"small"}
        ghost={false}
        loading={addButtonLoading || addAllButtonLoading}
        // disabled={(!addButtonLoading && segmentsCreateLoading) || (addAllButtonLoading && !isNested)}
        shape="round"
        icon={<PlusOutlined />}
        onClick={() => {
          if (isNested) {
            setAddAllButtonLoading(true);
          }
          addToSegment(addSegmentOptions);
        }}
      >
        {addButtonLoading ? <MrTranslate id={"CommonText.adding_button"} /> : <MrTranslate id={"CommonText.add"} />}
      </Button>
    </Tooltip>
  )
}

// export const GenerateAIButton = (props) => {

// } 

const RenderGeneratedQuestions = ({
  questions,
  questionType,
  marks,
  previousId,
  destinationPosition,
  nextDestinationPosition,
  createAtIndex,
  showCriteria,
  criteria,
  strands,
  commandTermId,
  syllabusTopicId,
  paperTypeId,
  teachingLevelId,
  difficultyLevelId,
  parentId,
}) => {  
  const generatedSegmentsRef = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      console.log("Rendering math");
      renderMathInElement(generatedSegmentsRef.current, true);
    }, 100);
  }, []);

  const activeTopicId = useSelector(activeTopicIdSelector());
  const activeExperience = useSelector(activeAdjustedExperienceSelector());
  const dispatch = useDispatch(); 
  const mrIntl = useTranslate();
  const [addAllButtonLoading, setAddAllButtonLoading] = useState(false)

  const generateQuestionRender = (q, i) => {
    console.log("question render==>", q)
    const isQuestionContentExist = (q.hasOwnProperty("question") && q.question !== ""); 
    const isNested = isQuestionContentExist && q.hasOwnProperty("sub_parts") && q.sub_parts.length > 0;
    const questionContent = q.question;
    return (
      <>
      {isQuestionContentExist && <Row key={i}>
        <Col span={2} style={{paddingLeft: "10px"}}> Q{i + 1} </Col>
        <Col span={17}>
          <>
            <RenderHtml text={questionContent} />
            {questionType === "mcq" && (
              <Space size={null} direction="vertical" className="m-t-5">
                {q.options.map((a, j) => (
                  <p
                    key={j}
                    className={`${
                      q.answer.trim() === a.trim() && "correct-answer"
                    } answer-choice`}
                  >
                    <Space>
                      <span>{String.fromCharCode(65 + j)}. </span>
                      {/* {a} */}
                      <RenderHtml text={a} />
                    </Space>
                  </p>
                ))}
              </Space>
            )}
            {questionType === "true_false" && `Answer - ${q.answer}`}
            {questionType === "nested_question" && (
              <Row className="m-t-10">
                {q.sub_parts.map((subPart, k) => (
                  <Col span={23} offset={1} key={`subpart-${k}`}>
                    <Row>
                      <Col span={2}>{String.fromCharCode(97 + k)} </Col>
                      <Col span={22}>
                        <RenderHtml text={subPart.question} />
                      </Col>
                    </Row>
                  </Col>
                ))}
              </Row>  
            )}
          </>
        </Col>
        <Col span={3} offset={1}>
          <AddGeneratedSegmentBtn
            content={q}
            criteria={criteria}
            marks={marks}
            strands={strands}
            showCriteria={showCriteria}
            questionType={questionType}
            previousId={isNested ? previousId : i} // sending i for now because assuming the nested question will be 3 sub parts
            destinationPosition={destinationPosition}
            createAtIndex={createAtIndex}
            commandTermId={commandTermId}
            syllabusTopicId={syllabusTopicId}
            paperTypeId={paperTypeId}
            teachingLevelId={teachingLevelId}
            difficultyLevelId={difficultyLevelId}
            parentId={parentId}
            addAllButtonLoading={addAllButtonLoading}
            setAddAllButtonLoading={setAddAllButtonLoading}
          />
        </Col>
      </Row>}
      </>
    );
  };

  const generatedQuestionsRender = questions.map(generateQuestionRender);
  
  

  
  const addAllQuestionsToSegments = () => {
    try {
      setAddAllButtonLoading(true);
      let index = 0;
      const addSegmentTimeoutValue = questionType === "nested_question" ? 4000 : 1000;
      const addQuestionWithDelay = (destinationPosition) => {
        if (index < questions.length) {
          setTimeout(() => {
            const question = questions[index];
            const position = getDestinationPositionLex(destinationPosition);
            const addSegmentOptions = {
              questionType,
              setAddAllButtonLoading,
              content: question,
              activeExperience,
              parentId,
              destinationPosition: position,
              previousId,
              marks,
              createAtIndex: index, // or provide the correct index for createAtIndex
              activeTopicId,
              dispatch,
              mrIntl,
              commandTermId,
              syllabusTopicId,
              paperTypeId,
              teachingLevelId,
              difficultyLevelId,
              showCriteria,
              criteria,
              strands,
              isNested: question.questionType === "nested_question", // Check if it's nested
              subPartLength: question.sub_parts ? question.sub_parts.length : 0, // Get sub part length if nested,
              addAll: true
            };

            addToSegment(addSegmentOptions);
            index++;
            addQuestionWithDelay(position); // Call recursively for the next question
          }, addSegmentTimeoutValue); // Add delay
        } else {
          message.success("All questions added successfully");
          setAddAllButtonLoading(false);
        }
      };
  
      addQuestionWithDelay(destinationPosition); // Start the loop
    } catch (error) {
      console.error("Error adding questions to segments:", error);
      message.error("An error occurred while adding questions to segments");
    }
  };
  
  

  return (
    <>
      <Row className="m-b-10">
        <Col span={19}>
          <h3 className="m-t-0 m-b-10">Questions generated by Assistant</h3>
        </Col>
        {process.env.REACT_APP_MODE !== "production" &&
          process.env.REACT_APP_MODE !== "china_production" &&
          questionType !== "nested_question" && (
            <Col span={5}>
              <Space>
                <Button
                  type="primary"
                  size={"small"}
                  ghost={false}
                  shape="round"
                  icon={<PlusOutlined />}
                  onClick={() => addAllQuestionsToSegments()}
                  loading={addAllButtonLoading}
                >
                  Add All
                </Button>
              </Space>
            </Col>
          )}
      </Row>
      <Space
        style={{ width: "100%" }}
        direction="vertical"
        size={20}
        ref={generatedSegmentsRef}
      >
        {generatedQuestionsRender}
      </Space>
    </>
  );
};

const GenerateAIWithPrompt = (props) => {
  console.log("GenerateAIWithPrompt==>", props)
  const { segment = {}, previousId, firstSegmentPosition, createAtIndex, parentId, createCondition, destinationPosition, nestingLevel } = props;
  const activeExperience = useSelector(activeAdjustedExperienceSelector());
  const currentUser = useSelector(currentUserSelector())
  const enabledFeatures = useSelector(enabledFeaturesSelector());
  const isDevelopmentOrStagingMode = (process.env.REACT_APP_MODE === "development" || process.env.REACT_APP_MODE === "staging") ? true : false;
  const aiModel = useSelector(aiModelSelector()); 
  const mrIntl= useTranslate()
  const [visible, setVisible] = useState(false);
  const [showError, setShowError] = useState(false);
 

 
  const [generatedQuestions, setGeneratedQuestions] = useState([]);
  const [pageRange, setPageRange] = useState({
    fromPage: 1,
    toPage: null,
  });

  let text_to_process = ""
  let question_type = "long_answer"
  let category = "similar";
  let videoUrl = "";
  let imageUrl = "";
  let pdfUrl = "";
  let similarTo;
  // let prompt;
  let programme_id = activeExperience && activeExperience.relation_items && activeExperience.relation_items[0] && activeExperience.relation_items[0].programme_id
  let programme_subject_id = activeExperience && activeExperience.relation_items && activeExperience.relation_items[0] && activeExperience.relation_items[0].programme_subject_id

  let programmeLabel;
  let orgProgrammeLabel;
  let subjectLabel;
  let gradeLabel;
  if(activeExperience && activeExperience.questionbank && activeExperience.questionbank.custom_fields) {
    programmeLabel = activeExperience.questionbank.custom_fields.programme_name
  }
  if(activeExperience &&
    activeExperience.custom_fields) {
    orgProgrammeLabel = activeExperience.custom_fields.org_programme_item_label
    subjectLabel = activeExperience.custom_fields.subject_item_label
    gradeLabel = activeExperience.custom_fields.grade_item_label
  }

 

  // const [itemType, setItemType] = useState([])
  // const [syllabuscontentsId, setSyllabusContentsId] = useState("")
  // setting null or "" uses the value in dataToPost - setting nothing - undefined - doesn't get included in object
  const rubric = activeExperience && activeExperience.rubric
  const points = segment && segment.points
  let defaultMarks = 0
  if ( rubric && rubric.type_c === "points") {
    if (points && createCondition === "similar") {
      defaultMarks = points
    } else {
      defaultMarks = 3
    }
  }
  // const defaultMarks = activeExperience && activeExperience.rubric && activeExperience.rubric.type_c === "points" ? segment && segment.points && createCondition === "similar" ? segment.points : 3 : 0;
  
  const [difficultyLevel, setDifficultyLevel] = useState()
  const [difficultyLevelId, setDifficultyLevelId] = useState()
  const [teachingLevel, setTeachingLevel] = useState();
  const [teachingLevelId, setTeachingLevelId] = useState();
  const [paperType, setPaperType] = useState();
  const [paperTypeId, setPaperTypeId] = useState()
  const [syllabusTopic, setSyllabusTopic] = useState();
  const [syllabusTopicId, setSyllabusTopicId] = useState()
  const [commandTerm, setCommandTerm] = useState()
  const [commandTermId, setCommandTermId] = useState()
  const [criteria, setCriteria] = useState()
  // const [criteriaForStrands, setCriteriaForStrands] = useState([])
  const [marks, setMarks] = useState(defaultMarks); // not null but 0 default for MYP
  const allCommandTerms = useSelector(commandTermsSelector())
  const allSyllabusTopics =
    activeExperience.standards_content_area_tag &&
    activeExperience.standards_content_area_tag.final_json
      ? activeExperience.standards_content_area_tag.final_json.data
      : [];
  const allOrgQuestionBanks = useSelector(orgquestionbanksSelector())
  const [promptUsed, setPromptUsed] = useState("")
  const [showPromptUsed, setShowPromptUsed] = useState(false)
  const [extractQuestions, setExtractQuestions] = useState(false)
  const [tokensUsed, setTokensUsed] = useState(0)
  const [requestCost, setRequestCost] = useState(0)
  const [questionsCount, setQuestionsCount] = useState(3);
  const [qbUUID, setQbUUID] = useState();
  const [useExamples, setUseExamples] = useState(false);
  const [useCustomExamples, setUseCustomExamples] = useState(false);
  const [useCustomPrompt, setUseCustomPrompt] = useState(false);
  const [customPrompt, setCustomPrompt] = useState("");
  const [customExamples, setCustomExamples] = useState("");
  const [additionalInstructions, setAdditionalInstructions] = useState("")
  const [selectStrands, setSelectStrands] = useState();
  const [questionType, setQuestionType] = useState(createCondition === "similar" ? question_type : "long_answer");
  const [sourceBasedOn, setSourceBasedOn] = useState("");
  const [sourceText, setSourceText] = useState(text_to_process);
  const [sourceImage, setSourceImage] = useState("");
  const [sourcePdf, setSourcePdf] = useState("")
  const cancelToken = useRef(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const mediaFormInitialState = {
    modal: false,
    loading: false,
    visible: false,
    from: 'computer',
    currentMediaType: '',
    okDisabled: true,
    triggerSaveAction: 0,
    limit: 1,
    fileUploading: false,
    supportedTypes: "image/jpg, image/jpeg, image/png, image/gif, image/bmp",
    selectConfig: {
      multiple: false,
      type: "pictures-wall"
    },
    onChangeSaveFiles: (files) => { 
      console.log("onChangeSaveFiles==>", files, sourceBasedOn, sourceImage, sourcePdf);
      if (files && files.length > 0) {
        setShowError(false);
        const fileType = files[0].type;
        const isPdf = fileType === "application/pdf";
        setSourcePdf(isPdf ? files[0].url : "");
        setSourceImage(isPdf ? "" : files[0].url);
        if (isPdf) {
          getPageCountFromURL(files[0].url).then((pageCount) => {
            console.log("total pages==>", pageCount);
            setPageRange({
              fromPage: 1,
              toPage: pageCount,
            });
          });
        }
      }
    },
    onRemoveFile: (file) => {
      console.log("onRemoveFile==>", file);
      setSourceImage("");
      setSourcePdf("");
    }
  }
  const [mediaFormSetting, setMediaFormSetting] = useState(mediaFormInitialState);

  useEffect(() => {
    const settingsMap = {
      pdf: {
        supportedTypes: "application/pdf",
        supportedFormats: 'pdf',
        selectConfig: {
          ...mediaFormSetting.selectConfig,
          maxSize: "30 MB",
        }
      },
      image: {
        supportedTypes: "image/jpg, image/jpeg, image/png, image/gif, image/bmp",
        supportedFormats: 'jpg, jpeg, png, gif, bmp',
        selectConfig: {
          ...mediaFormSetting.selectConfig,
          maxSize: "20 MB",
        }
      },
    };
  
    setMediaFormSetting({
      ...mediaFormSetting,
      ...settingsMap[sourceBasedOn],
    });
  }, [sourceBasedOn]);
  


  useEffect(() => {
    if (segment && createCondition === "similar") {
      let firstRelationItem =
        segment.relation_items && segment.relation_items[0];
      let updatedCommandTerm
      let updatedSyllabusTopic
      let difficultyLevelId;
      let difficultyLevelLabel;
      let teachingLevelId;
      let teachingLevelLabel;
      // let paperType;

      if (firstRelationItem) {
        if (
          firstRelationItem.command_term_items &&
          firstRelationItem.command_term_items.length > 0
        ) {
          updatedCommandTerm = firstRelationItem.command_term_items[0].label;
          setCommandTerm(updatedCommandTerm);
        }
        if (firstRelationItem.difficulty_level_tag_ids && firstRelationItem.difficulty_level_tag_ids.length > 0) {
          difficultyLevelId = firstRelationItem.difficulty_level_tag_ids[0];
          setDifficultyLevelId(difficultyLevelId)
        }
        if (firstRelationItem.difficulty_level_items && firstRelationItem.difficulty_level_items.length > 0) {
          difficultyLevelLabel = firstRelationItem.difficulty_level_items[0].label;
          setDifficultyLevel(difficultyLevelLabel)
        }
        if (firstRelationItem.teaching_level_tag_ids && firstRelationItem.teaching_level_tag_ids.length > 0) {
          teachingLevelId = firstRelationItem.teaching_level_tag_ids[0];
          setTeachingLevelId(teachingLevelId)
        }
        if (firstRelationItem.teaching_level_items && firstRelationItem.teaching_level_items.length > 0) {
          teachingLevelLabel = firstRelationItem.teaching_level_items[0].label;
          setTeachingLevel(teachingLevelLabel)
        }

        if (
          firstRelationItem.syllabus_items &&
          firstRelationItem.syllabus_items.length > 0
        ) {
          updatedSyllabusTopic = firstRelationItem.syllabus_items[0].label;
          setSyllabusTopic(updatedSyllabusTopic);
        }
      }
      console.log("updatedCommandTerm==>", difficultyLevel, teachingLevel)

      if (activeExperience && activeExperience.relation_items) {
        const firstActiveExperienceRelation =
          activeExperience.relation_items[0];

        if (
          firstActiveExperienceRelation &&
          firstActiveExperienceRelation.paper_type_items &&
          firstActiveExperienceRelation.paper_type_items.length > 0
        ) {
          setPaperType(firstActiveExperienceRelation.paper_type_items[0].label);
        }

        // if (
        //   firstActiveExperienceRelation &&
        //   firstActiveExperienceRelation.teaching_level_items &&
        //   firstActiveExperienceRelation.teaching_level_items.length > 0
        // ) {
        //   setTeachingLevel(
        //     firstActiveExperienceRelation.teaching_level_items[0].label
        //   );
        // }
      }
    }
  }, []);



  const allPaperTypes = useSelector((state) => {
    return state.request.get("papertype")
  })

  const allDifficultyLevels = useSelector((state) => {
    return state.request.get("difficultylevels")
  })

  const allTeachingLevels = useSelector((state) => {
    return state.request.get("teachinglevels")
  })
  // const [showAdditionalInstructions, setShowAdditionalInstructions] = useState(false);


  const segmentType = segment && segment.segment_type;

  if (segmentType === "question") {
    const questionType = segment.question_segment_attributes.question_type;
    const segmentContent = segment.question_segment_attributes.content;
    if (questionType === "cke_subjective") {
      question_type = "long_answer"
      if (createCondition === "similar") {
        similarTo = removeHTMLTagsFromText(segmentContent, true)
      }
      text_to_process = segmentContent
    } else if (questionType.includes('mcq')) {
      text_to_process = segmentContent
      question_type = "mcq"
    } else {
      text_to_process = segmentContent
      question_type = questionType
    }
  } else if (segmentType === "text") {
    text_to_process = removeHTMLTagsFromText(segment.text_segment_attributes.content, true)
    question_type = "long_answer"
  } else if (segmentType === "resource") {
    const resourceType = segment.resource_segment_attributes && segment.resource_segment_attributes.resource_type;
    const resourceJsonAttachments = segment.resource_segment_attributes && segment.resource_segment_attributes.resource_json && segment.resource_segment_attributes.resource_json.segment_data && segment.resource_segment_attributes.resource_json.segment_data.attachments && segment.resource_segment_attributes.resource_json.segment_data.attachments[0];

    if (resourceType === "video" && resourceJsonAttachments.transcript) {
      question_type = "long_answer"
      text_to_process = removeHTMLTagsFromText(resourceJsonAttachments.transcript, true)
      category = "passage_based"
      videoUrl = resourceJsonAttachments.url
    } else if (resourceType === "image") {
      imageUrl = resourceJsonAttachments.url;
    } else if (resourceType === "pdf") {
      pdfUrl = resourceJsonAttachments.url;
    }
  }

  // let disableOptions = false;
  // if (!createNew) {
  //   if (segment.segment_type === "question") {
  //     disableOptions = true;
  //   }
  // }
  const currentSubjectLabel =
    activeExperience &&
    activeExperience.custom_fields &&
    activeExperience.custom_fields.subject_item_label;
  const isMYPSubjectSyllabusTopicFilterAvailable =
    currentSubjectLabel &&
    showSyllabusTopicFilterForMYPSubjectsInAIModal.some(
      (item) => item.toLowerCase() === currentSubjectLabel.toLowerCase()
    );
  const isDPSubjectSyllabusTopicFilterAvailable =
    currentSubjectLabel &&
    showSyllabusTopicFilterForDPSubjectsInAIModal.some(
      (item) => item.toLowerCase() === currentSubjectLabel.toLowerCase()
    );

  const isMYPProgram =
    activeExperience.questionbank &&
    activeExperience.questionbank.custom_fields.programme_name
      ? activeExperience.questionbank.custom_fields.programme_name.includes(
          "IB Middle Years"
        )
      : activeExperience.custom_fields && activeExperience.custom_fields.org_programme_item_label &&
        activeExperience.custom_fields.org_programme_item_label.includes(
          "IB Middle Years"
        );

  const isDPProgram =
    activeExperience.questionbank &&
    activeExperience.questionbank.custom_fields.programme_name
      ? activeExperience.questionbank.custom_fields.programme_name.includes(
          "IB Diploma"
        )
      : activeExperience.custom_fields && activeExperience.custom_fields.org_programme_item_label &&
        activeExperience.custom_fields.org_programme_item_label.includes(
          "IB Diploma"
        );

  const isMypAl = activeExperience && activeExperience.rubric && activeExperience.rubric.type_c === "myp_achievement_level"



  let isFullScreenModal = (segment.segment_type === "resource" && segment.resource_segment_attributes && segment.resource_segment_attributes.resource_type === "video") || (segment.segment_type === "text" && segment.text_segment_attributes.content && segment.text_segment_attributes.content)

  let showGenerateAIButton =
    createCondition === "new" ||
    segment.segment_type === "text" ||
    (segment.segment_type === "question" &&
      segment.question_segment_attributes &&
      segment.question_segment_attributes.question_type === "cke_subjective") ||
    (segment.segment_type === "resource" &&
      segment.resource_segment_attributes.resource_type === "video") ||
    (segment.segment_type === "resource" &&
      segment.resource_segment_attributes.resource_type === "image") ||
    (segment.segment_type === "resource" &&
      segment.resource_segment_attributes.resource_type === "pdf");


  const textToRender = (
    segment.segment_type === "resource" && segment.resource_segment_attributes && segment.resource_segment_attributes.resource_type === "video" &&
    segment.resource_segment_attributes.resource_json.segment_data
      .attachments[0] &&
    segment.resource_segment_attributes.resource_json.segment_data
      .attachments[0].transcript &&
    segment.resource_segment_attributes.resource_json.segment_data
      .attachments[0].transcript) || (segment.segment_type === "text" && segment.text_segment_attributes.content && segment.text_segment_attributes.content)

  // const mediaPlayer = useRef(null);


  console.log('empty segment==>', isEmpty(segment))
  const skeletonDataSource = [...Array(3).keys()];
  const isContentExistForAllQuestions = generatedQuestions.filter((q) => q.question !== "" && q.hasOwnProperty("question")).length > 0;
  const isCorrectAnswerExistForAllQuestions = questionType === "mcq" ? generatedQuestions.every(q => q.hasOwnProperty("answer") && q.answer !== "" && q.options.includes(q.answer)) : true;
  const shouldShowQuestions = isContentExistForAllQuestions && isCorrectAnswerExistForAllQuestions;

  const isBasedOnText =
    createCondition === "based_on" &&
    segment &&
    segment.segment_type === "text";

  const isBasedOnQuestion =
    (createCondition === "based_on" || createCondition === "similar") &&
    segment &&
    segment.segment_type === "question" &&
    segment.question_segment_attributes.question_type === "cke_subjective";

  const isBasedOnVideo =
    createCondition === "based_on" &&
    segment &&
    segment.segment_type === "resource" && segment.resource_segment_attributes.resource_type === "video";

  const isBasedOnImage = createCondition === "based_on" && segment && segment.segment_type === "resource" && segment.resource_segment_attributes.resource_type === "image";

  const isBasedOnPdf = createCondition === "based_on" && segment && segment.segment_type === "resource" && segment.resource_segment_attributes.resource_type === "pdf";
  console.log("based on checking==>", createCondition, segment)

  const tooltipTitle =
    createCondition === "new"
      ? mrIntl("GenerateAIWithPrompt.auto_generate_question_title")
      : segment.segment_type === "text"
      ? mrIntl("GenerateAIWithPrompt.generate_questions_from_this_text_title")
      : segment.segment_type === "resource"
      ? mrIntl("GenerateAIWithPrompt.generate_questions_from_this_video_title")
      : mrIntl("GenerateAIWithPrompt.generate_similar_questions");

  const questionTypes = [
    {
      label: mrIntl("CommonText.long_answer"),
      value: "long_answer",
    },
    {
      label: mrIntl("CommonText.mcq_single_label"),
      value: "mcq",
    },
    
    
    // {
    //   label: mrIntl("CommonText.true_false"),
    //   value: "true_false",
    // },
    // {
    //   label: mrIntl("CommonText.drawing"),
    //   value: "fabric_drawing",
    // },
    // {
    //   label: mrIntl("CommonText.label_drag"),
    //   value: "fabric_dnd_label",
    // },
    // {
    //   label: mrIntl("CommonText.label_fill"),
    //   value: "fabric_fill_label",
    // },
    // {
    //   label: mrIntl("CommonText.hotspot"),
    //   value: "fabric_hotspot",
    // },
    // {
    //   label: mrIntl("CommonText.geogebra_graph"),
    //   value: "ggb_graph",
    // },
    // {
    //   label: mrIntl("CommonText.desmos_graph"),
    //   value: "desmos_graph",
    // },
    // {
    //   label: mrIntl("CommonText.match"),
    //   value: "rbd_inline_matching",
    // },
    // {
    //   label: mrIntl("CommonText.sort"),
    //   value: "rbd_inline_sorting",
    // },
    // {
    //   label: mrIntl("CommonText.classify"),
    //   value: "rbd_inline_classify",
    // },
    // // {
    // //   label: mrIntl("CommonText.table"),
    // //   value: "rds_table",
    // // },
    // {
    //   label: mrIntl("CommonText.fill_text"),
    //   value: "cke_fill_text",
    // },
    // {
    //   label: mrIntl("CommonText.fill_dropdown"),
    //   value: "cke_fill_dropdown",
    // },
    // { label: mrIntl("CommonText.group"), value: "group" },
    // {
    //   label: mrIntl("CommonText.connect"),
    //   value: "connect",
    // },
  ]
  console.log("nestingLevel==>", nestingLevel, isDPProgram, isDevelopmentOrStagingMode, questionType)
  if (isDPProgram && isDevelopmentOrStagingMode && nestingLevel === 1) {
    questionTypes.push({
      label: "Question with sub-parts",
      value: "nested_question",
    });
  }

  let sourceBasedOnOptions = [
    { label: "Text", value: "text" }
  ]
  if (enabledFeatures.ai_generate_questions_from_image || isDevelopmentOrStagingMode) {
    sourceBasedOnOptions.push({ label: "Image", value: "image" })
  }
  if (enabledFeatures.ai_generate_questions_from_pdf || isDevelopmentOrStagingMode || currentUser.role === "qb_author") {
    sourceBasedOnOptions.push({ label: "PDF", value: "pdf" })
  }



  const promptConfig = {
    showExtractQuestionsSwitch: ((enabledFeatures.ai_generate_questions_from_pdf || isDevelopmentOrStagingMode) && (sourceBasedOn === "pdf" || isBasedOnPdf)) && !useCustomPrompt,
    showQuestionType: (isMYPProgram || isDPProgram),
    showCriteria: isMYPProgram && activeExperience.rubric.type_c !== "comments_only" && !useCustomPrompt,
    showDPFilters: isDPProgram && !useCustomPrompt,
    showPointsInput: activeExperience.rubric && activeExperience.rubric.type_c === "points" && !useCustomPrompt,
    showSyllabusTopicsDropdown: ((isMYPProgram && isMYPSubjectSyllabusTopicFilterAvailable) || (isDPProgram && isDPSubjectSyllabusTopicFilterAvailable)) && !useCustomPrompt, 
    showCommandTermDropdown: (isMYPProgram || isDPProgram) && !useCustomPrompt,
    showAdditionalInstructions: !useCustomPrompt,
    showCustomPromptCheckbox: currentUser.role === "qb_author",
    showUseExamplesCheckbox: currentUser.role === "qb_author" && !useCustomPrompt,
    showTokenUsageCost: currentUser.role === "qb_author",
    showPromptButton: currentUser.role === "qb_author",
    showPageRangeInput:
      (enabledFeatures.ai_generate_questions_from_pdf ||
        isDevelopmentOrStagingMode) &&
      (sourceBasedOn === "pdf" || isBasedOnPdf) &&
      !useCustomPrompt &&
      sourcePdf !== "",
  };


  
  


  const showModal = () => {
    
    setVisible(true);
    if(createCondition === "new"){
      setCommandTerm()
      setSyllabusTopic()
      setPaperTypeId()
      setDifficultyLevelId()
      setTeachingLevelId()
    }
  };

  const handleOk = (e) => {
    setVisible(false);
  };

  const handleCancel = (e) => {
    setCriteria([]);
    setSelectStrands([])
    setGeneratedQuestions([])
    setShowError(false)
    setVisible(false);
    setSourceBasedOn("")
    setShowPromptUsed(false)
    setExtractQuestions(false);
    if (cancelToken.current) {
      cancelToken.current.cancel('Request canceled by the user');
    }
  };


  const getGeneratedQuestions = async () => {
    const source = axios.CancelToken.source();
    cancelToken.current = source;
    console.log("pageRange==>", pageRange)

    if (questionType === "nested_question" && marks < 3) {
      setShowError(true);
      return;
    }

    if (promptConfig.showCriteria && (criteria || []).length === 0) {
      setShowError(true);
      return
    }
    if (useExamples && !qbUUID) {
      setShowError(true)
      return;
    }
    if (sourceBasedOn !== "") {
      if (sourceBasedOn === "text") {
        if (!sourceText) {
          setShowError(true)
          return;
        }
      } 
      if (sourceBasedOn === "image") {
        if (sourceImage === "") {
          setShowError(true)
          return;
        }
      }
      console.log("sourceBasedOn==>", sourceBasedOn, sourcePdf, sourceImage, sourceText)
      if (sourceBasedOn === "pdf") {
        if (sourcePdf === "") {
          setShowError(true)
          return;
        }
        if (pageRange.fromPage === null || pageRange.toPage === null || (pageRange.fromPage > pageRange.toPage)) {
          setShowError(true);
          return;
        }
      }
    }
    console.log("checking criteria", criteria)
    setLoading(true);
    // set the disabled property inside mediaFormSetting.selectConfig.disabled
    setMediaFormSetting({
      ...mediaFormSetting,
      selectConfig: {
        ...mediaFormSetting.selectConfig,
        disabled: true,
      },
    });
    setError("")
    const token = getFromLS("token");
    setGeneratedQuestions([]);

    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      cancelToken: source.token
    };
    config = updateConfigHeaderForDemoUseStagingAI(config)

    let commandTermId;
    // let questionBankUUID;
    let paperTypeLabel;
    let difficultyLevelLabel;
    let teachingLevelLabel;

    if(commandTerm ) {
      const selectedCommandTerm = find(allCommandTerms, (ct) => ct.name === commandTerm)
      commandTermId = selectedCommandTerm && selectedCommandTerm.id
      setCommandTermId(commandTermId)
    }
    if(paperTypeId) {
      const selectedPaperType = find(allPaperTypes, (ct) => ct.id === paperTypeId)
      paperTypeLabel = selectedPaperType && selectedPaperType.name
      setPaperType(paperTypeLabel)
    }
    if(difficultyLevelId) {
      const selectedDifficultyLevel = find(allDifficultyLevels, (ct) => ct.id === difficultyLevelId)
      difficultyLevelLabel = selectedDifficultyLevel && selectedDifficultyLevel.name
      setDifficultyLevel(difficultyLevelLabel)
    }
    if(teachingLevelId) {
      const selectedTeachingLevel = find(allTeachingLevels, (ct) => ct.id === teachingLevelId)
      teachingLevelLabel = selectedTeachingLevel && selectedTeachingLevel.name
      setTeachingLevel(teachingLevelLabel)
    }
    
    // if (qbId) {
    //   questionBankUUID = find(allOrgQuestionBanks, qb => qb.questionbank_id === qbId).qb_uuid
    // }

    

    let syllabusTopicUUID;
    if (syllabusTopic) {
      syllabusTopicUUID = findSyllabusTopicKey(
        allSyllabusTopics,
        syllabusTopic,
        "uuid"
      );
      const syllabusTopicId = findSyllabusTopicKey(
        allSyllabusTopics,
        syllabusTopic,
        "id"
      );
      setSyllabusTopicId(syllabusTopicId);
    }
    let subjectId;
    let gradeId;
    let orgProgrammeId;
    let programmeId;
    
    if (
      activeExperience &&
      activeExperience.relation_items &&
      activeExperience.relation_items[0]
    ) {
      subjectId = activeExperience.relation_items[0].subject_id;
      gradeId = activeExperience.relation_items[0].grade_id;
      orgProgrammeId = activeExperience.relation_items[0].org_programme_id;
      programmeId = activeExperience.relation_items[0].programme_id;
    }
    
    console.log("sending params==>", {paperType, allPaperTypes}, {difficultyLevel, allDifficultyLevels}, {teachingLevel, allTeachingLevels})

    let buildPromptOnBE = true
    // if ((showPromptUsed && promptUsed) || useCustomPrompt) {
    if (useCustomPrompt) {
      buildPromptOnBE = false
    }
    let dataToPost = {}

    // (segment.segment_type === "resource" || segment.segment_type === "text") ? createCondition === "based_on" ? segment.segment_type === "resource" && segment.resource_segment_attributes.resource_type === "image" ? "image" : "text" : "" : createCondition === "new" && sourceBasedOn ? sourceBasedOn : "",

    const segmentType = segment.segment_type;
    const resourceType = segment.resource_segment_attributes && segment.resource_segment_attributes.resource_type;

    let basedOn = "";
    if ((segmentType === "resource" || segmentType === "text") && createCondition === "based_on") {
      if (segmentType === "resource" && resourceType === "image") {
        basedOn = "image";
      } else {
        basedOn = "text";
      }
      if (segmentType === "resource" && resourceType === "pdf") {
        basedOn = "pdf";
      }
    } else if (createCondition === "new" && sourceBasedOn) {
      basedOn = sourceBasedOn;
    } 


    // segment.segment_type === "resource" ?
    //    segment.resource_segment_attributes.resource_type === "image" ? 
    //     imageUrl 
    //     : text_to_process 
    //   : segment.segment_type === "text" ? text_to_process : sourceBasedOn ? sourceBasedOn === "text" ? sourceText : sourceBasedOn === "image" ? sourceImage : "" : ""
    let basedOnValue = ""
    if (segmentType === "resource") {
      if (resourceType === "image") {
        basedOnValue = imageUrl;
      } else if (resourceType === "pdf") {
        basedOnValue = pdfUrl;
      } else {
        basedOnValue = text_to_process;
      }
    } else if (segmentType === "text") {
      basedOnValue = text_to_process;
    } else if (sourceBasedOn) {
      if (sourceBasedOn === "text") {
        basedOnValue = sourceText;
      } else if (sourceBasedOn === "image") {
        basedOnValue = sourceImage;
      } else if (sourceBasedOn === "pdf") {
        basedOnValue = sourcePdf;
      }
    }


    if(buildPromptOnBE){

      dataToPost = {
        // prompt: prompt // works when we want prompt from FE - but moving to BE
        segment_type: "question",
        child_segment_type: questionType,
        number_of_segments: Number(questionsCount),
        programme_label: programmeLabel,
        org_programme_label: orgProgrammeLabel,
        subject_label: subjectLabel,
        grade_label: gradeLabel,
        paper_type_label: paperTypeLabel,
        paper_type_id: paperTypeId,
        difficulty_level_label: difficultyLevelLabel,
        difficulty_level_id: difficultyLevelId,
        teaching_level_label: teachingLevelLabel,
        teaching_level_id: teachingLevelId,
        syllabus_topic_label: syllabusTopic,
        syllabus_topic_uuid: syllabusTopicUUID,
        command_term_label: commandTerm,
        command_term_id: commandTermId,
        // criteria_label: "criteria",
        criteria: criteria,
        strands: selectStrands,
        
        subject_id: subjectId,
        grade_id: gradeId,
        org_programme_id: orgProgrammeId,
        programme_id: programmeId,
        // myp_al_level_label: "1-2",
        similar_to: similarTo,
        based_on: basedOn,
        based_on_value: basedOnValue,
        use_examples: useExamples,
        // custom_examples: customExamples,
        user_role: currentUser.role,
        extract_questions: extractQuestions,
        from_page: pageRange.fromPage,
        to_page: pageRange.toPage,
      }
      if (activeExperience.rubric.type_c === "points") {
        dataToPost.points = parseFloat(marks)
      }
      if (additionalInstructions) {
        dataToPost = {
          ...dataToPost,
          additional_instructions: additionalInstructions
        }
      }
      if(useExamples) { // so that qb_uuid is not sent if !useExamples
        dataToPost = {
          ...dataToPost,
          qb_uuid: qbUUID
        }
      }

    } else {

      dataToPost = {
        user_role: currentUser.role,
        segment_type: "question",
        child_segment_type: questionType,
        number_of_segments: Number(questionsCount),
        prompt: customPrompt,
        // prompt: promptUsed || customPrompt, // disabled supporting modification of BE prompt
        // custom_examples: customExamples,
        based_on: basedOn,
        based_on_value: basedOnValue,
        programme_label: programmeLabel,
        org_programme_label: orgProgrammeLabel,
        subject_label: subjectLabel,
        grade_label: gradeLabel,
      }
    }
    if(aiModel) {
      dataToPost.model = aiModel
    }

    try {
      // await axios.post(`${process.env.REACT_APP_AI_SERVICE_URL}/generate-using-prompt`, dataToPost, config)
      await axios.post(`${getAIServiceBaseURL()}/generate-segments`, dataToPost, config)
      .then(function (response) {
        console.log('generating questions==>', response, paperType)
        let finalResponse;
        if (response && response.data && response.data.text) {
          finalResponse = response.data.text.split("\n");
        } else {
          finalResponse = response.data.questions;
          setPromptUsed(response.data.prompt_used)
          setRequestCost(response.data.request_cost)
          setTokensUsed(response.data.total_used)
        }
        setGeneratedQuestions(finalResponse)
        setLoading(false);
        setMediaFormSetting({
          ...mediaFormSetting,
          selectConfig: {
            ...mediaFormSetting.selectConfig,
            disabled: false,
          },
        });
      })
      .catch(function (error) {
        console.log("error==>", error);
        console.log(error);
        if (error.message !== "Request canceled by the user") {  
          setError(true)
        }
        setLoading(false);
        setMediaFormSetting({
          ...mediaFormSetting,
          selectConfig: {
            ...mediaFormSetting.selectConfig,
            disabled: false,
          },
        });
      });

    } catch (error) {
      console.error(error);
    }
  }
  
 

  const magicButtonRenderInFooter =
    <MagicButton
      tooltipTitle={
        !questionsCount
          ? mrIntl(
            "GenerateAIWithPrompt.please_enter_number_of_questions"
          )
          : loading ? mrIntl("GenerateAIWithPrompt.stop_generating") : ""
      }
      type={!loading && "primary"}
      shape="default"
      icon={loading && <FaRegStopCircle style={{marginTop: "3px"}} />}
      disabled={!questionsCount || !questionType || showError || mediaFormSetting.fileUploading}
      onClick={() => {
        if (loading) {
          if (cancelToken.current) {
            cancelToken.current.cancel('Request canceled by the user');
          }
        } else {
          getGeneratedQuestions()
        }
      }}
      // disabled={loading}
      text={generatedQuestions.length > 0 ? mrIntl("GenerateAIWithPrompt.generate_more") : loading ? null : mrIntl("GenerateAIWithPrompt.generate_button")}
    />

  return (
    <>
      {/* <Button type="primary" onClick={showModal}>
        Share
      </Button> */}
      {showGenerateAIButton ? (
        createCondition === "new" ? (
          <MagicButton
            tooltipTitle={tooltipTitle}
            tooltipPlacement="top"
            shape="default"
            size="medium"
            ghost={true}
            onClick={showModal}
            text={
              <MrTranslate
                id={"GenerateAIWithPrompt.generate_with_ai_button"}
              />
            }
          />
        ) : (
          <MagicButton
            // mode="subtle"
            tooltipTitle={tooltipTitle}
            tooltipPlacement="top"
            type={"text"}
            size="medium"
            onClick={showModal}
          />
        )
      ) : null}

      {visible ? (
        <Modal
          title={<ModalTitle />}
          open={visible}
          footer={
            <ModalFooter
              magicButtonRenderInFooter={magicButtonRenderInFooter}
              error={error}
              generatedQuestions={generatedQuestions}
            />
          }
          onOk={handleOk}
          onCancel={handleCancel}
          width={"75%"}
          wrapClassName={
            "full-screen-modal height-centered-modal generate-ai-modal"
          }
        >
          <Row gutter={24}>
            <Col
              className="generate-ai-modal-param-col"
              span={10}
            >
              <Space direction="vertical" style={{width: "100%"}}>
                <Space className="m-b-10">
                  {programmeLabel && <Tag>{programmeLabel}</Tag>}
                  {orgProgrammeLabel && <Tag>{orgProgrammeLabel}</Tag>}
                  {subjectLabel && <Tag>{subjectLabel}</Tag>}
                  {gradeLabel && <Tag>{gradeLabel}</Tag>}
                </Space>
                {isBasedOnText && (
                    <>
                      <span>Based on this text</span>
                      <ShowText>
                        {/* <RenderHtml text={content} /> */}
                        <ShowTextContent
                          className="show-text-answer"
                          dangerouslySetInnerHTML={{
                            __html: segment.text_segment_attributes.content
                          }}
                        ></ShowTextContent>
                      </ShowText>
                    </>
                  )}
                {isBasedOnQuestion && (
                    <>
                      <span>Similar to this question</span>
                      <ShowText>
                        {/* <RenderHtml text={content} /> */}
                        <ShowTextContent
                          className="show-text-answer"
                          dangerouslySetInnerHTML={{
                            __html: segment.question_segment_attributes.content,
                          }}
                        ></ShowTextContent>
                      </ShowText>
                    </>
                  )}
                {isBasedOnImage && (
                  <>
                    <span>Based on this image</span>
                    <MediaShow mediaType={"image"} file={segment.resource_segment_attributes.resource_json.segment_data.attachments[0]} />
                  </>
                )}
                {isBasedOnPdf && (
                  <>
                    <span>Based on this pdf</span>
                    <MediaShow mediaType={"pdf"} file={segment.resource_segment_attributes.resource_json.segment_data.attachments[0]} />
                  </>
                )}
                {isBasedOnVideo && (
                    <Space direction="vertical" className="video-player-space">
                      <span>Based on this video</span>
                      <ReactPlayer
                        key={`react-player`}
                        width={"100%"}
                        height={"300px"}
                        // ref={mediaPlayer}
                        url={
                          segment.segment_type === "resource" &&
                          segment.resource_segment_attributes &&
                          segment.resource_segment_attributes.resource_type ===
                            "video" &&
                          segment.resource_segment_attributes.resource_json
                            .segment_data.attachments[0] &&
                          segment.resource_segment_attributes.resource_json
                            .segment_data.attachments[0].url
                        }
                      />
                    </Space>
                  )}

                {showPromptUsed ? (
                  <TextArea
                    className="prompt-used-textarea"
                    value={promptUsed}
                    rows={30}
                    onChange={(e) => {
                      setPromptUsed(e.target.value);
                    }}
                  />
                ) : (
                  <div className="select-parameters">
                    {createCondition === "new" && 
                    <Space direction="vertical" className="m-b-10">
                      <span>Source</span>
                        <Space direction="horizontal">
                        <Radio.Group
                          options={sourceBasedOnOptions}
                          disabled={loading}
                          onChange={(e) => {
                            setSourceText("");
                            setSourceImage("");
                            setSourcePdf("");
                            setPageRange({fromPage: "", toPage: ""})
                            setExtractQuestions(false);
                            setSourceBasedOn(e.target.value);
                            setShowError(false);
                          }}
                          value={sourceBasedOn}
                          optionType="button"
                          buttonStyle="solid"
                        /> 
                        {sourceBasedOn !== "" && <Button disabled={loading} icon={<CloseCircleOutlined />} type="text" onClick={() => {
                          setShowError(false);
                          setSourceBasedOn("");
                          setExtractQuestions(false);
                          setPageRange({fromPage: "", toPage: ""})
                        }} size="small" />}
                        </Space>
                       
                        {sourceBasedOn === "text" && (
                          <>
                            <CKETextContent
                              ckeConfig={{...CKETextGenerateAISourceTools, isReadOnly: loading}}
                              writingAssistantConfig={{enabled: true, loading: loading}}
                              value={sourceText}
                              placeholder={"Add source text"}
                              onChange={(text) => {
                                setShowError(false);
                                setSourceText(text);
                              }}
                            />
                            {showError && sourceText === "" && <Text type="danger" >Please add source text</Text>}
                          </>
                        )}
                        {(sourceBasedOn === "image" || sourceBasedOn === "pdf") && (
                          <div>
                            <SelectFromComputer
                              key={`select-from-computer-${sourceBasedOn}`}
                              mediaFormSetting={mediaFormSetting}
                              setMediaFormSetting={setMediaFormSetting}
                              computer={true}
                              url={false}
                            />
                            {showError && (sourceBasedOn === "image" ? sourceImage === "" : sourcePdf === "") && <Text type="danger" >Please select file</Text>}
                          </div>
                        )}

                    </Space>}

                    {promptConfig.showExtractQuestionsSwitch && (
                      <Space direction="vertical" className="m-b-10">
                        <span>Extract questions</span>
                        <Switch
                          checked={extractQuestions}
                          onChange={(value) => setExtractQuestions(value)}
                          disabled={loading}
                        />
                      </Space>
                    )}
                    {promptConfig.showPageRangeInput && (
                      <Space direction="vertical" className="m-b-10">
                        <span>{mrIntl("GenerateAIWithPrompt.page_range")}</span>
                        <Space direction="horizontal">
                            <InputNumber
                              style={{width: "150px"}}
                              addonBefore={mrIntl("GenerateAIWithPrompt.from")}
                              min={1}
                              max={pageRange.toPage}
                              value={pageRange.fromPage}
                              onChange={(value) => {
                                setShowError(false);
                                setPageRange({...pageRange, fromPage: value})
                              }}
                              disabled={loading}
                              controls={false}
                            />
                            <InputNumber
                              style={{width: "150px"}}
                              addonBefore={mrIntl("GenerateAIWithPrompt.to")}
                              min={1}
                              max={pageRange.toPage}
                              value={pageRange.toPage}
                              onChange={(value) => {
                                setShowError(false);
                                setPageRange({...pageRange, toPage: value})
                              }}
                              disabled={loading}  
                              controls={false}
                            />
                        </Space>
                        {showError && ((pageRange.fromPage === null || pageRange.toPage === null) ? <Text type="danger">{mrIntl("GenerateAIWithPrompt.required")}</Text> : (pageRange.fromPage > pageRange.toPage) ? <Text type="danger">{mrIntl("GenerateAIWithPrompt.from_page_value_should_be_less_than_to_page_value")}</Text> : null)}
                      </Space>
                    )}
                    {/* TODO: hide all other params if extractQuestions true */}


                    {promptConfig.showQuestionType && (
                      <Space direction="vertical" className="m-b-10">
                        <span>Select question type</span>
                        <Select
                          onChange={(value) => {
                            setGeneratedQuestions([]);
                            setQuestionType(value);
                          }}
                          className="select-question-type"
                          value={questionType}
                          placeholder="Select question type"
                          options={questionTypes}
                          disabled={loading}
                        />
                      </Space>
                    )}

                    {promptConfig.showCriteria && (
                      <Space direction="vertical" className="m-b-10">
                        <SelectCriteria
                          // disabled={disableOptions}
                          criteria={criteria}
                          setCriteria={setCriteria}
                          showError={showError}
                          setShowError={setShowError}
                          segment={createCondition === "similar" && segment}
                          disabled={loading}
                          isMypAl={isMypAl}
                        />
                        {criteria && criteria.length > 0 && (
                          <SelectStrandsForm
                            // disabled={disableOptions}
                            segment={segment}
                            strands={selectStrands}
                            setSelectStrands={setSelectStrands}
                            criteria={criteria}
                            disabled={loading}
                          />
                        )}
                      </Space>
                    )}
                    {promptConfig.showSyllabusTopicsDropdown && (
                      <Space direction="vertical" className="m-b-10">
                        <span>Syllabus topic</span>
                        <SelectTreeSyllabusContentsSingle
                          // disabled={disableOptions}
                          value={syllabusTopic}
                          onChange={(e) => {
                            console.log(
                              "SelectTreeSyllabusContentsSingle==>",
                              e
                            );
                            setSyllabusTopic(e);
                          }}
                          config={{
                            forceReload: true,
                            // params: {
                            //   by_programme_id: programme_id,
                            //   by_programme_subject_id: programme_subject_id,
                            // },
                            widgetConfig: { 
                              style: { width: "350px" },
                              options: activeExperience.standards_content_area_tag || {},
                              // grade_label:  activeExperience.custom_fields.grade_item_label, // Note: would be incorrect to use grade_item_label - need programme_grade_label
                            },
                          }}
                          disabled={loading}
                        />
                      </Space>
                    )}
                    {promptConfig.showCommandTermDropdown && (
                      <Space direction="vertical" className="m-b-10">
                        <span>Command term</span>
                        <SelectCommandTermLabel
                          // disabled={disableOptions}
                          value={commandTerm}
                          onChange={(value) => {
                            console.log("SetCommandTerm===>", value)
                            setCommandTerm(value)
                          }}
                          config={{
                            params: { by_programme_id: programme_id },
                            widgetConfig: { style: { width: "200px" } },
                          }}
                          disabled={loading}
                        />
                      </Space>
                    )}
                    {promptConfig.showDPFilters && (
                      <>
                        <Space direction="vertical" className="m-b-10">
                          <span>Difficulty</span>
                          {/* <GenericFilter
                            showClearButton={true}
                            label={mrIntl(
                              "GenerateAIWithPrompt.select_difficulty_level"
                            )}
                            options={[
                              {
                                label: mrIntl(
                                  "GenerateAIWithPrompt.accessible_label"
                                ),
                                value: "accessible",
                              },
                              {
                                label: mrIntl(
                                  "GenerateAIWithPrompt.moderate_label"
                                ),
                                value: "moderate",
                              },
                              {
                                label: mrIntl(
                                  "GenerateAIWithPrompt.hard_label"
                                ),
                                value: "hard",
                              },
                            ]}
                            value={difficultyLevel}
                            keyToUpdate="by_tag_difficulty_levels"
                            onChange={(value) => setDifficultyLevel(value)}
                            config={{
                              widgetConfig: {
                                // style: { "100%" : "15vw" },
                                // allowClear: !filtersConfig.showModal,
                              },
                            }}
                          /> */}
                          <SelectDifficultyLevel
                            value={difficultyLevelId}
                            // disabled={disableOptions}
                            key="selectDifficultyLevel"
                            // onChange={(value) => props.setParams({by_tag_difficulty_levels: value ? [value] : []})}
                            onChange={(value) => {
                              setDifficultyLevelId(value)
                            }}
                            config={{
                              params: { by_programme_id: programme_id },
                              widgetConfig: {
                                style: { width: "200px" },
                                // mode: "multiple",
                                placeholder: mrIntl("CommonText.all_levels"),
                              },
                            }}
                            disabled={loading}
                          />
                        </Space>
                        <Space direction="vertical" className="m-b-10">
                          <span>Paper type</span>
                          {/* <GenericFilter
                            showClearButton={true}
                            label={mrIntl(
                              "GenerateAIWithPrompt.select_paper_type"
                            )}
                            options={[
                              {
                                label: mrIntl(
                                  "GenerateAIWithPrompt.paper_1_label"
                                ),
                                value: "Paper 1",
                              },
                              {
                                label: mrIntl(
                                  "GenerateAIWithPrompt.paper_2_label"
                                ),
                                value: "Paper 2",
                              },
                              {
                                label: mrIntl(
                                  "GenerateAIWithPrompt.paper_3_label"
                                ),
                                value: "Paper 3",
                              },
                            ]}
                            value={paperType}
                            disabled={disableOptions}
                            keyToUpdate="by_paper_difficulty_levels"
                            onChange={(value) => setPaperType(value)}
                            config={{
                              widgetConfig: {
                                // style: { "100%" : "15vw" },
                                // allowClear: !filtersConfig.showModal,
                              },
                            }}
                          /> */}
                          <SelectPaperType
                            key="selectPaperTypeFilter"
                            // disabled={disableOptions}
                            value={paperTypeId}
                            onChange={(value) => {
                              setPaperTypeId(value);
                            }}
                            config={{
                              widgetConfig: {
                                style: { width: "200px" },
                                // mode: "multiple",
                                placeholder: mrIntl("CommonText.all_papers"),
                              },
                            }}
                            disabled={loading}
                          />
                        </Space>
                        <Space direction="vertical" className="m-b-10">
                          <span>Teaching level</span>
                          {/* <GenericFilter
                            showClearButton={true}
                            label={mrIntl(
                              "GenerateAIWithPrompt.select_teaching_type"
                            )}
                            options={[
                              {
                                label: mrIntl(
                                  "GenerateAIWithPrompt.sl_only_label"
                                ),
                                value: "SL only",
                              },
                              {
                                label: mrIntl(
                                  "GenerateAIWithPrompt.sl_and_hl_label"
                                ),
                                value: "SL & HL",
                              },
                              {
                                label: mrIntl("GenerateAIWithPrompt.hl_label"),
                                value: "HL only",
                              },
                            ]}
                            value={teachingLevel}
                            disabled={disableOptions}
                            keyToUpdate="by_paper_difficulty_levels"
                            onChange={setTeachingLevel}
                            config={{
                              widgetConfig: {
                                // style: { "100%" : "15vw" },
                                // allowClear: !filtersConfig.showModal,
                              },
                            }}
                          /> */}
                          <SelectTeachingLevel
                            // disabled={disableOptions}
                            key="selectTeachingTypeFilter"
                            value={teachingLevelId}
                            onChange={(value) => {
                              setTeachingLevelId(value);
                            }}
                            config={{
                              widgetConfig: {
                                hideSl: true,
                                style: { width: "200px" },
                                // mode: "multiple",
                                placeholder: mrIntl("CommonText.all_levels"),
                              },
                            }}
                            disabled={loading}
                          />
                        </Space>
                      </>
                    )}
                    {promptConfig.showPointsInput && (
                      <Space direction="vertical" className="m-b-10">
                        <span>Points</span>
                        <InputNumber
                          min={1}
                          addonBefore={"Enter points"}
                          className="points-input"
                          value={marks}
                          onChange={(value) => {
                            if (questionType === "nested_question" && value >= 3 && showError) {
                              setShowError(false);
                            }
                            if (typeof value === "number") {
                              setMarks(value);
                            } else {
                              setMarks(1);
                            }
                          }}
                          disabled={loading}
                        />
                        {showError && questionType === "nested_question" && marks < 3 && <Text type="danger">Marks should be 3 or more for nested questions</Text>}
                      </Space>
                    )}
                    <br />
                    {promptConfig.showAdditionalInstructions && <Space direction="vertical" className="m-b-10">
                      <span>
                        {mrIntl("GenerateAIWithPrompt.additional_instructions")}
                      </span>
                      <TextArea
                        value={additionalInstructions}
                        onChange={(e) =>
                          setAdditionalInstructions(e.target.value)
                        }
                        maxLength={300}
                        className="additional-instructions-textarea"
                        autoSize={{ minRows: 2, maxRows: 6 }}
                        placeholder={mrIntl(
                          "GenerateAIWithPrompt.enter_additional_instructions"
                        )}
                        disabled={loading}
                      />
                    </Space>}

                    {promptConfig.showCustomPromptCheckbox && <Space direction="vertical" className="m-b-10 custom-prompt-space">
                      <Checkbox
                        checked={useCustomPrompt}
                        onChange={(e) => setUseCustomPrompt(e.target.checked)}
                      >
                        <span>Use custom prompt</span>
                      </Checkbox>
                      {useCustomPrompt && (
                        <>
                          <CKETextContent
                            ckeConfig={{...CKETextGenerateAISourceTools, isReadOnly: loading}}
                            writingAssistantConfig={{enabled: true, loading: loading}}
                            value={customPrompt}
                            placeholder={"Add custom prompt"}
                            onChange={(value) => {
                              setShowError(false);
                              setCustomPrompt(value);
                            }}
                          />
                        </>
                      )}
                    </Space>}
                    
                    {promptConfig.showUseExamplesCheckbox && false && <Space direction="vertical" className="m-b-10">
                      <Checkbox
                        checked={useCustomExamples}
                        onChange={(e) => setUseCustomExamples(e.target.checked)}
                      >
                        <span>Use custom examples</span>
                      </Checkbox>
                      {useCustomExamples && (
                        <>
                          <CKETextContent
                            ckeConfig={{...CKETextGenerateAISourceTools, isReadOnly: loading}}
                            writingAssistantConfig={{enabled: true, loading: loading}}
                            value={customExamples}
                            placeholder={"Add custom examples"}
                            onChange={(value) => {
                              setShowError(false);
                              setCustomExamples(value);
                            }}
                          />
                        </>
                      )}
                    </Space>
                    }

                    {promptConfig.showUseExamplesCheckbox && <Space direction="vertical" className="m-b-10">
                        <Checkbox
                          checked={useExamples}
                          onChange={(e) => setUseExamples(e.target.checked)}
                        >
                          <span>Use examples from banks</span>
                        </Checkbox>
                        {useExamples && (
                          <>
                            <br />
                            <SelectQuestionbankUUID
                              dropdownMatchSelectWidth={false}
                              key="selectQuestionbank"
                              value={qbUUID}
                              onChange={(value) => {
                                console.log("value==>", value);
                                setQbUUID(value);
                                setShowError(false);
                              }}
                              config={{
                                params: {
                                  // without_qb_codes:
                                  //   currentUser.role !== "qb_author"
                                  //     ? ["osc_dp_mocks"]
                                  //     : [],
                                  by_programme_id:
                                    activeExperience.questionbank.programme_id,
                                },
                                widgetConfig: {
                                  style: { width: "250px" },
                                },
                              }}
                            />
                            <br />
                            {showError && useExamples && !qbUUID && (
                              <Text type="danger">
                                Please select questionbank
                              </Text>
                            )}
                          </>
                        )}
                    </Space>}
                  </div>
                )}
                {/* <SelectPaperType key="selectPaperTypeFilter" value={paperType} onChange={(value) => setPaperType(value)} config={{ widgetConfig: { mode: "multiple", style: { width: '150px' } } }} /> */}
                {/* {props.withAddButton && <Input addonBefore={mrIntl("GenerateAIWithPrompt.enter_topic")} value={syllabusTopic} onChange={(e) => setSyllabusTopic(e.target.value)} />} */}
                {/* {!showPromptUsed && } */}
                {/* {props.withAddButton && <Input addonBefore={mrIntl("GenerateAIWithPrompt.command_term")} value={commandTerm} onChange={(e) => setCommandTerm(e.target.value)} />} */}
                {/* {
                  <Space direction="vertical">
                    
                  </Space>
                } */}
                {/* <Input required addonBefore={"Number of questions"} value={questionsCount} onChange={(e) => setQuestionsCount(e.target.value)} /> */}
                {/* {!showPromptUsed && <Checkbox
                  onChange={(e) =>
                    setShowAdditionalInstructions(e.target.checked)
                  }
                >
                  {mrIntl("GenerateAIWithPrompt.additional_instructions")}
                </Checkbox>}
                {!showPromptUsed && showAdditionalInstructions && (
                  <TextArea
                    value={additionalInstructions}
                    onChange={(e) => setAdditionalInstructions(e.target.value)}
                    rows={2}
                    placeholder={mrIntl(
                      "GenerateAIWithPrompt.enter_additional_instructions"
                    )}
                  />
                )} */}
                {promptConfig.showPromptButton &&
                  generatedQuestions.length > 0 && (
                    <Button onClick={() => setShowPromptUsed(!showPromptUsed)}>
                      {showPromptUsed ? "Hide prompt" : "See prompt"}
                    </Button>
                  )}
                {promptConfig.showTokenUsageCost &&
                  generatedQuestions.length > 0 && (
                    <Space>
                      <Tag>Tokens: {tokensUsed}</Tag>
                      <Tag>Cost: ${requestCost}</Tag>
                    </Space>
                  )}
              </Space>
            </Col>
            <Col span={14} className="generated-questions">
              {loading && (
                <div className="loading-div">
                  <List
                    itemLayout="vertical"
                    size="large"
                    dataSource={skeletonDataSource}
                    renderItem={(item) => (
                      <List.Item>
                        <Skeleton active></Skeleton>
                      </List.Item>
                    )}
                  />
                </div>
              )}
              {generatedQuestions.length > 0 && (shouldShowQuestions ?
                <RenderGeneratedQuestions
                  marks={marks}
                  criteria={criteria}
                  showCriteria={promptConfig.showCriteria}
                  strands={selectStrands}
                  commandTermId={commandTermId}
                  syllabusTopicId={syllabusTopicId}
                  questions={generatedQuestions}
                  questionType={questionType}
                  previousId={previousId}
                  destinationPosition={destinationPosition}
                  createAtIndex={createAtIndex}
                  paperTypeId={paperTypeId}
                  teachingLevelId={teachingLevelId}
                  difficultyLevelId={difficultyLevelId}
                  parentId={parentId}
                />
                :
                <Empty
                  description={mrIntl("GenerateAIWithPrompt.something_went_wrong_in_generating_questions_please_try_again")}
                />
              )}
              {/* {generatedQuestions.length > 0 && (
                <div className="rate-ai-results">
                  <RateAiResult generatedData={generatedQuestions} action="generate_segments"/>
                </div>
              )} */}
              {generatedQuestions.length === 0 && !loading && (
                <>
                  <Empty
                    description={mrIntl(
                      "GenerateAIWithPrompt.please_click_generate_to_see_questions_description"
                    )}
                  />
                   <Alert  
                      type="info"
                      message={<span>
                        <p>1. {mrIntl("GenerateAIWithPrompt.provide_clear_concise_instructions_with_specific_keywords_for_more_relevant")}</p>
                        <p>2. {mrIntl("GenerateAIWithPrompt.do_not_include_any_personal_or_sensitive_information_in_your")}</p>
                        <p>3. {mrIntl("GenerateAIWithPrompt.while_our_ai_assistant_is_advanced_it_is_not_perfect")}</p>
                      </span>}
                    />
                </>
              )}
            </Col>
          </Row>
        </Modal>
      ) : null}
    </>
  );
};


export default GenerateAIWithPrompt;
